import type { AABB } from './aabb';

export type HandleType = 'nw' | 'n' | 'ne' | 'w' | 'e' | 'sw' | 's' | 'se';

export interface Handle {
  type: HandleType;
  x: number;
  y: number;
}

export function getHandles(bbox: AABB, scale: number): Handle[] {
  const { x, y, width, height } = bbox;
  const hx = [x, x + width / 2, x + width];
  const hy = [y, y + height / 2, y + height];
  const types: HandleType[] = ['nw', 'n', 'ne', 'w', 'e', 'sw', 's', 'se'];
  const handles: Handle[] = [];
  let idx = 0;
  for (let iy = 0; iy < 3; iy++) {
    for (let ix = 0; ix < 3; ix++) {
      if (ix === 1 && iy === 1) continue;
      handles.push({ type: types[idx++], x: hx[ix], y: hy[iy] });
    }
  }
  return handles;
}

// 화면 좌표(픽셀)로 변환하는 헬퍼 함수
export function worldToScreen(worldX: number, worldY: number, scale: number, offset: { x: number; y: number }): { x: number; y: number } {
  return {
    x: worldX * scale + offset.x,
    y: worldY * scale + offset.y
  };
}

export function hitTestHandle(
  screenX: number, // 화면 픽셀 좌표
  screenY: number, // 화면 픽셀 좌표
  handles: Handle[],
  scale: number,
  offset: { x: number; y: number },
  rotation?: number,
  centerX?: number,
  centerY?: number
): HandleType | null {
  // 화면 픽셀 기준 16px 영역으로 직접 비교
  // 원형 객체의 모서리 핸들이 객체 외부에 있어도 클릭 가능하도록 넉넉하게 설정
  const threshold = 16; // 화면 픽셀 기준
  
  // 회전이 있으면 마우스 좌표를 역회전하여 로컬 좌표계로 변환
  let testScreenX = screenX;
  let testScreenY = screenY;
  if (rotation && Math.abs(rotation) > 1e-6 && centerX !== undefined && centerY !== undefined) {
    // 화면 좌표를 월드 좌표로 변환
    const worldX = (screenX - offset.x) / scale;
    const worldY = (screenY - offset.y) / scale;
    // 객체 중심 기준 역회전
    const dx = worldX - centerX;
    const dy = worldY - centerY;
    const cos = Math.cos(-rotation);
    const sin = Math.sin(-rotation);
    const localX = centerX + dx * cos - dy * sin;
    const localY = centerY + dx * sin + dy * cos;
    // 다시 화면 좌표로 변환
    testScreenX = localX * scale + offset.x;
    testScreenY = localY * scale + offset.y;
  }
  
  for (const h of handles) {
    // 핸들 위치를 화면 좌표로 변환
    const handleScreen = worldToScreen(h.x, h.y, scale, offset);
    const dx = Math.abs(testScreenX - handleScreen.x);
    const dy = Math.abs(testScreenY - handleScreen.y);
    if (dx <= threshold && dy <= threshold) return h.type;
  }
  return null;
}

